export type ClassificationName =
    | 'Luxury'
    | 'Premium'
    | 'Mainstream'
    | 'Value'
    | 'Budget'
    | 'Unclassified';

export class BrandClassification {
    private constructor(
        public readonly name: ClassificationName,
        public readonly priority: number,
        public readonly colourId: number
    ) { }

    private static readonly _classifications = new Map<ClassificationName, BrandClassification>([
        ['Unclassified', new BrandClassification('Unclassified', 0, 0)],
        ['Budget', new BrandClassification('Budget', 1, 5)],
        ['Value', new BrandClassification('Value', 2, 7)],
        ['Mainstream', new BrandClassification('Mainstream', 3, 6)],
        ['Premium', new BrandClassification('Premium', 4, 1)],
        ['Luxury', new BrandClassification('Luxury', 5, 2)],
    ]);

    public static fromString(classification: string | null | undefined): BrandClassification {
        if (!classification) return this._classifications.get('Unclassified')!;
        return this._classifications.get(classification as ClassificationName) ?? this._classifications.get('Unclassified')!;
    }

    public static getAll(): BrandClassification[] {
        return Array.from(this._classifications.values())
            .sort((a, b) => b.priority - a.priority);
    }
}
